import { useNotification } from '@gohighlevel/ghl-ui'

export const useNotificationEvent = () => {
  const notification = useNotification()
  const enableNotification = (params: {
    title: string
    description?: string
    content?: string
    type?: 'default' | 'error' | 'info' | 'success' | 'warning'
    duration?: number
  }) => {
    notification.create({
      ...params,
      duration: params.duration || 5000,
    })
  }

  const delay = (wait: number) =>
    new Promise(resolve => setTimeout(resolve, wait))

  return {
    enableNotification,
    delay,
  }
}
